import PropTypes from "prop-types"
import React, { useEffect } from "react"
import Signup from "src/main/User/Signup"

import Divider from "src/components/Divider"

import { useTracker } from "src/hooks/use_tracker"

import { accountBenefitPropType } from "./Submitted/CreateAccountCard"

const ContractSignUp = ({
  title,
  subtitle,
  benefitsTitle,
  emailLockedNote,
  benefits,
  contact,
  minimumPasswordLength,
  quoteId,
  marina,
}) => {
  const tracker = useTracker()

  useEffect(() => {
    tracker.trackEvent("contracts_v2:sign_up_viewed", {
      contract_quote_id: quoteId,
      marina_id: marina.id,
      marina_name: marina.name,
    })
  }, [tracker, quoteId, marina.id, marina.name])

  return (
    <div className="w-full">
      <h1 className="m-0 text-[42px] font-bold leading-tight text-gray-900">
        {title}
      </h1>
      <p className="mb-6 mt-2 text-base font-semibold text-gray-900">
        {subtitle}
      </p>
      <Divider />
      <div className="mt-8 flex flex-col gap-8 lg:grid lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-7">
          <p className="mb-2 text-sm font-semibold text-gray-700">{title}</p>
          <div className="rounded-lg border border-gray-300 bg-white p-6">
            <Signup
              minimumPasswordLength={minimumPasswordLength}
              defaultValues={{
                first_name: contact.firstName || "",
                last_name: contact.lastName || "",
                email: contact.email,
                displayPhone: contact.phone || "",
              }}
              emailLocked
              emailLockedNote={emailLockedNote}
              submitLabel={title}
              hiddenFields={{ contract_quote: quoteId }}
              experienceName="contract_sign_up"
            />
          </div>
        </div>
        <div className="lg:col-span-5">
          <p className="mb-2 text-sm font-semibold text-gray-700">
            {benefitsTitle}
          </p>
          <div className="rounded-lg border border-gray-300 bg-white p-6">
            <ul className="m-0 flex list-none flex-col gap-5 p-0">
              {benefits.map((benefit) => (
                <li key={benefit.title} className="flex items-center gap-4">
                  <i className={`${benefit.icon} fa-fw fa-xl text-teal-600`} />
                  <div>
                    <p className="m-0 font-semibold text-gray-900">
                      {benefit.title}
                    </p>
                    <p className="m-0 text-sm text-gray-700">
                      {benefit.description}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

ContractSignUp.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  benefitsTitle: PropTypes.string.isRequired,
  emailLockedNote: PropTypes.string.isRequired,
  benefits: PropTypes.arrayOf(accountBenefitPropType).isRequired,
  contact: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string,
  }).isRequired,
  minimumPasswordLength: PropTypes.number.isRequired,
  quoteId: PropTypes.string.isRequired,
  marina: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

export default ContractSignUp
